import { render, staticRenderFns } from "./MeetingAgendasContainer.vue?vue&type=template&id=2ef6c289&"
import script from "./MeetingAgendasContainer.vue?vue&type=script&lang=js&"
export * from "./MeetingAgendasContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ef6c289')) {
      api.createRecord('2ef6c289', component.options)
    } else {
      api.reload('2ef6c289', component.options)
    }
    module.hot.accept("./MeetingAgendasContainer.vue?vue&type=template&id=2ef6c289&", function () {
      api.rerender('2ef6c289', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/MeetingAgendasContainer.vue"
export default component.exports